import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { constants } from 'constants/constants';

enum MODAL_TITLE {
  GENERAL = 'Please confirm rejection of the following credential',
  TEST_REGISTRATION = 'Please confirm you wish to reject the test that has been assigned to you',
}

@Component({
  selector: 'cm-certificate-reject-modal',
  templateUrl: './certificate-reject-modal.component.html',
  styleUrls: ['./certificate-reject-modal.component.scss'],
})
export class CertificateRejectModalComponent implements OnInit {
  @Input() isLoggedAsProfessional = false;

  @Input() certificate;

  certificateName: string;
  isTestRegistrationTemplate = false;
  title = 'Please confirm rejection of the following credential';
  body = `
          If you feel this has been assigned in error, you must contact your credential board to resolve.
				  Contact information for all credential boards can be found at this`;
  link = `http://www.internationalcredentialing.org/memberboards`;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.certificateName = this.certificate.certificate_name;
    this.isTestRegistrationTemplate =
      this.certificate.certificate_template_id === constants.CERTIFICATION_TEMPLATE.TEST_REGISTRATION;
    this.title =
      this.isTestRegistrationTemplate && !this.isLoggedAsProfessional
        ? MODAL_TITLE.TEST_REGISTRATION
        : MODAL_TITLE.GENERAL;
  }

  confirm() {
    this.activeModal.close();
  }

  back() {
    this.activeModal.dismiss();
  }
}
